"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
var mobx_1 = require("mobx");
var CreateTaxGroup = /** @class */ (function () {
    function CreateTaxGroup() {
        this.taxLines = [];
    }
    Object.defineProperty(CreateTaxGroup.prototype, "totalPercent", {
        get: function () {
            var total = 0;
            this.taxLines.forEach(function (taxLine) { return total += (taxLine.percent || 0); });
            return total;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        mobx_1.observable
    ], CreateTaxGroup.prototype, "name", void 0);
    __decorate([
        mobx_1.computed
    ], CreateTaxGroup.prototype, "totalPercent", null);
    __decorate([
        mobx_1.observable
    ], CreateTaxGroup.prototype, "taxLines", void 0);
    return CreateTaxGroup;
}());
exports.CreateTaxGroup = CreateTaxGroup;
var UpdateTaxGroup = /** @class */ (function (_super) {
    __extends(UpdateTaxGroup, _super);
    function UpdateTaxGroup() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        mobx_1.observable
    ], UpdateTaxGroup.prototype, "id", void 0);
    return UpdateTaxGroup;
}(CreateTaxGroup));
exports.UpdateTaxGroup = UpdateTaxGroup;
var TaxIDs;
(function (TaxIDs) {
    TaxIDs[TaxIDs["GST"] = 1] = "GST";
    TaxIDs[TaxIDs["PST (BC)"] = 2] = "PST (BC)";
    TaxIDs[TaxIDs["HST (Ontario)"] = 3] = "HST (Ontario)";
    TaxIDs[TaxIDs["GST (Alberta)"] = 4] = "GST (Alberta)";
    TaxIDs[TaxIDs["PST (Saskatchewan)"] = 5] = "PST (Saskatchewan)";
    TaxIDs[TaxIDs["RST (Manitoba)"] = 6] = "RST (Manitoba)";
    TaxIDs[TaxIDs["PST (Quebec)"] = 7] = "PST (Quebec)";
    TaxIDs[TaxIDs["HST"] = 8] = "HST";
    TaxIDs[TaxIDs["State tax (California)"] = 9] = "State tax (California)";
    TaxIDs[TaxIDs["Uniform local tax (California)"] = 10] = "Uniform local tax (California)";
    TaxIDs[TaxIDs["State tax (Colorado)"] = 11] = "State tax (Colorado)";
    TaxIDs[TaxIDs["IPO"] = 12] = "IPO";
    TaxIDs[TaxIDs["IVA CF"] = 13] = "IVA CF";
    TaxIDs[TaxIDs["IVA"] = 14] = "IVA";
    TaxIDs[TaxIDs["Online store tax"] = 15] = "Online store tax";
    TaxIDs[TaxIDs["First nation cannabis tax"] = 16] = "First nation cannabis tax";
    TaxIDs[TaxIDs["Vape PST (BC)"] = 17] = "Vape PST (BC)";
    TaxIDs[TaxIDs["VPT (Saskatchewan)"] = 18] = "VPT (Saskatchewan)";
    TaxIDs[TaxIDs["LCT (Saskatchewan)"] = 19] = "LCT (Saskatchewan)";
})(TaxIDs = exports.TaxIDs || (exports.TaxIDs = {}));
//# sourceMappingURL=TaxGroup.js.map